import { render, staticRenderFns } from "./RecentActivityWrap.vue?vue&type=template&id=8965af7c&scoped=true&"
import script from "./RecentActivityWrap.vue?vue&type=script&lang=js&"
export * from "./RecentActivityWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8965af7c",
  null
  
)

export default component.exports